import { BOARD_TYPE, ICoordinates, PLAYER_NUMBER } from "../../pages/GamePlay/types"
import { _has, _includes } from "../../utils/helpers/zupeeLodash"
import { BOARD_CONFIG, COMMON_BOXES, OUTER_PATH_LENGTH, TWO_PLAYER_CONFIG } from "./constant"
// import { ICoordinates, PLAYER_NUMBER } from "./types"
import dayjs from 'dayjs'

export function formatTime(seconds: number) {
  return dayjs().startOf('year').add(Math.max(seconds, 0), 'second').format('mm:ss')
}

export function calculateCoordinates(
  playerNumber: PLAYER_NUMBER,
  position: number
): ICoordinates | undefined {
  const boardConfig = TWO_PLAYER_CONFIG;
  if (!boardConfig) {
    return
  }
  
  if (position <= boardConfig.OUTER_PATH_LENGTH - 2) {
    // console.log({position, OUTER_PATH_LENGTH })
    // console.log("<><><><>", COMMON_BOXES[(position) % OUTER_PATH_LENGTH])
    return boardConfig.COMMON_BOXES[(position + boardConfig.START_POSITIONS[playerNumber]) % boardConfig.OUTER_PATH_LENGTH]
  } 
  else if (position <= boardConfig.PATH_FINAL_INDEX - 1) {
    return boardConfig?.HOME_BOXES[playerNumber]?.[position - (boardConfig.OUTER_PATH_LENGTH - 1)]
  } else if (position === boardConfig.PATH_FINAL_INDEX) {
    return boardConfig.FINAL_BOXES[playerNumber]?.[0]
  }
}

// export function checkIsLongStep(boardType: BOARD_TYPE, playerNumber: PLAYER_NUMBER, position: number) {
//   const boardConfig = BOARD_CONFIG[boardType]
//   if (boardConfig && position <= boardConfig.OUTER_PATH_LENGTH - 2) {
//     const absPosition = (position + boardConfig.START_POSITIONS[playerNumber]) % boardConfig.OUTER_PATH_LENGTH
//     if (boardConfig.POSITIONS_BEFORE_LONG_STEP.includes(absPosition)) {
//       return true
//     }
//   }
//   return false
// }

// export function checkIsLongStep(
//   boardType: BOARD_TYPE,
//   playerNumber: PLAYER_NUMBER,
//   position: number
// ): boolean {
//   const boardConfig = TWO_PLAYER_CONFIG;

//   // Ensure boardConfig and position are valid
//   if (!boardConfig || position < 0) {
//     return false; // Default to `false` if inputs are invalid
//   }

//   const { OUTER_PATH_LENGTH, START_POSITIONS, POSITIONS_BEFORE_LONG_STEP } = boardConfig;

//   // Validate boardConfig properties
//   if (
//     typeof OUTER_PATH_LENGTH !== "number" ||
//     !Array.isArray(START_POSITIONS) ||
//     !Array.isArray(POSITIONS_BEFORE_LONG_STEP)
//   ) {
//     return false; // Default to `false` for invalid configuration
//   }

//   // Safeguard for playerNumber key access
//   const startPosition = START_POSITIONS[playerNumber];
//   if (typeof startPosition !== "number") {
//     return false; // Default to `false` if the player's start position is undefined
//   }

//   if (position <= OUTER_PATH_LENGTH - 2) {
//     const absPosition = (position + startPosition) % OUTER_PATH_LENGTH;

//     // Check if absPosition is in POSITIONS_BEFORE_LONG_STEP
//     if (POSITIONS_BEFORE_LONG_STEP.includes(absPosition)) {
//       return true;
//     }
//   }

//   return false; // Default to `false` if conditions are not met
// }

export function checkIsLongStep(boardType: BOARD_TYPE, playerNumber: PLAYER_NUMBER, position: number) {
  const boardConfig = TWO_PLAYER_CONFIG
  if (position <= boardConfig?.OUTER_PATH_LENGTH - 2) {
    const absPosition = (position + boardConfig.START_POSITIONS[playerNumber]) % boardConfig?.OUTER_PATH_LENGTH
    if (_includes(boardConfig.POSITIONS_BEFORE_LONG_STEP, absPosition)) {
      return true
    }
  }
  return false
}


export function boxNumberToShowHandAnimation(boardConfig= TWO_PLAYER_CONFIG, commonBoxes: any, initialIndex: number) {
  const { SAFE_POSITIONS } = boardConfig || {}
  const total_boxes = 52
  let pos = initialIndex
  let count = 1

  while (count <= total_boxes) {
    const isNotSafePosition = !_includes(SAFE_POSITIONS, pos)
    const commonBoxesHasPos = _has(commonBoxes, pos) && commonBoxes[pos]?.length === 1
    if (isNotSafePosition && commonBoxesHasPos) {
      const kukriObject = commonBoxes[pos]?.[0]
      if (kukriObject?.playerNumber !== PLAYER_NUMBER.ONE) {
        return pos
      }
    }
    count++
    pos++
    if (pos >= total_boxes) {
      pos = 0
    }
  }
  return -1
}